import { Button } from "@whitespace/components";
import AptusContext from "@whitespace/gatsby-plugin-smorgasbord-aptus-booking/src/contexts/aptusContext";
import { apartmentContext } from "@whitespace/gatsby-plugin-smorgasbord-fastapi";
import {
  ErrorMessage,
  Loading,
} from "@whitespace/gatsby-theme-smorgasbord/src/components";
import clsx from "clsx";
import { add, format, parseISO } from "date-fns";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation, Trans } from "react-i18next";

import useAptusBooking from "../hooks/useAptusBooking";

import * as defaultStyles from "./ConfirmationScreen.module.css";

ConfirmationScreen.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  day: PropTypes.object.isRequired,
  pass: PropTypes.object.isRequired,
};

async function handleAddToCalendar() {
  // @TODO Create add to calendar functionality
  console.log("add to calendar");
}

export default function ConfirmationScreen({
  styles = defaultStyles,
  className,
  day,
  pass,
}) {
  const { t } = useTranslation();
  const { groups, setBookings, setBookedPass } = useContext(AptusContext);
  const { del, get, response, loading, error } = useAptusBooking({
    headers: {
      "Content-Type": "application/json",
    },
  });
  const [bookingId, setBookingId] = useState(null);
  const { selectedApartment } = useContext(apartmentContext);
  async function getNewBooking() {
    const { data } = await get(`/apartments/${selectedApartment.id}/bookings`);
    const newBooking = data[data.length - 1];
    setBookingId(newBooking.bookingId);
  }

  useEffect(() => {
    if (selectedApartment) {
      getNewBooking();
    }
  }, [selectedApartment]);

  async function handleCancelBooking() {
    await del(`/apartments/${selectedApartment.id}/bookings`, {
      bookingId,
    });
    if (response.ok) {
      setBookedPass(null);
      setBookings([]); // Clear entire array to fetch all bookings again from API
    }
  }

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorMessage error={error} />;
  }

  const groupName = groups.find((group) => group.id == day.groupId).name;
  const date = parseISO(day.date).toLocaleDateString("sv", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
  const startTime = parseISO("1970-01-01 " + pass.StartTime);
  const start = startTime.toLocaleTimeString("sv", {
    hour: "2-digit",
    minute: "2-digit",
  });
  const end = add(startTime, {
    minutes: pass.LengthMinutes,
  }).toLocaleTimeString("sv", {
    hour: "2-digit",
    minute: "2-digit",
  });
  const timeRange = `${start}–${end}`;

  return (
    <div className={clsx(styles.component, className)}>
      <p>
        <Trans i18nKey="bookingConfirmationMessage">
          You have booked <strong>{{ groupName }}</strong> on{" "}
          <strong>{{ date }}</strong> between <strong>{{ timeRange }}</strong>.
        </Trans>
      </p>
      {/* <Link onClick={() => handleAddToCalendar()}>{t("addToCalendar")}</Link> */}
      <Button onClick={() => handleCancelBooking()}>{t("cancel")}</Button>
    </div>
  );
}
